// AUTOGENERATED FILE - DO NOT EDIT

/**
 * All IAM policy actions for AWS IoT Events (IOTEVENTS)
 *
 * Extracted by `aws-iam-policy` from
 * https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiotevents.html
 *
 * 2025-02-24T21:48:23.958Z
 */
export enum AwsIoteventsActions {
  /**
   * Grants permission to send one or more acknowledge action requests to AWS IoT Ev
   * ents
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_iotevents-data_BatchAcknowledgeAlarm.html
   */
  BatchAcknowledgeAlarm = 'iotevents:BatchAcknowledgeAlarm',
  /**
   * Grants permission to delete a detector instance within the AWS IoT Events syste
   * m
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_iotevents-data_BatchDeleteDetector.html
   */
  BatchDeleteDetector = 'iotevents:BatchDeleteDetector',
  /**
   * Grants permission to disable one or more alarm instances
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_iotevents-data_BatchDisableAlarm.html
   */
  BatchDisableAlarm = 'iotevents:BatchDisableAlarm',
  /**
   * Grants permission to enable one or more alarm instances
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_iotevents-data_BatchEnableAlarm.html
   */
  BatchEnableAlarm = 'iotevents:BatchEnableAlarm',
  /**
   * Grants permission to send a set of messages to the AWS IoT Events system
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_iotevents-data_BatchPutMessage.html
   */
  BatchPutMessage = 'iotevents:BatchPutMessage',
  /**
   * Grants permission to reset one or more alarm instances
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_iotevents-data_BatchResetAlarm.html
   */
  BatchResetAlarm = 'iotevents:BatchResetAlarm',
  /**
   * Grants permission to change one or more alarm instances to the snooze mode
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_iotevents-data_BatchSnoozeAlarm.html
   */
  BatchSnoozeAlarm = 'iotevents:BatchSnoozeAlarm',
  /**
   * Grants permission to update a detector instance within the AWS IoT Events syste
   * m
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_iotevents-data_BatchUpdateDetector.html
   */
  BatchUpdateDetector = 'iotevents:BatchUpdateDetector',
  /**
   * Grants permission to create an alarm model to monitor an AWS IoT Events input a
   * ttribute or an AWS IoT SiteWise asset property
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_CreateAlarmModel.html
   */
  CreateAlarmModel = 'iotevents:CreateAlarmModel',
  /**
   * Grants permission to create a detector model to monitor an AWS IoT Events input
   * attribute
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_CreateDetectorModel.html
   */
  CreateDetectorModel = 'iotevents:CreateDetectorModel',
  /**
   * Grants permission to create an Input in IotEvents
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_CreateInput.html
   */
  CreateInput = 'iotevents:CreateInput',
  /**
   * Grants permission to delete an alarm model
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_DeleteAlarmModel.html
   */
  DeleteAlarmModel = 'iotevents:DeleteAlarmModel',
  /**
   * Grants permission to delete a detector model
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_DeleteDetectorModel.html
   */
  DeleteDetectorModel = 'iotevents:DeleteDetectorModel',
  /**
   * Grants permission to delete an input
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_DeleteInput.html
   */
  DeleteInput = 'iotevents:DeleteInput',
  /**
   * Grants permission to retrieve information about an alarm instance
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_iotevents-data_DescribeAlarm.html
   */
  DescribeAlarm = 'iotevents:DescribeAlarm',
  /**
   * Grants permission to retrieve information about an alarm model
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_DescribeAlarmModel.html
   */
  DescribeAlarmModel = 'iotevents:DescribeAlarmModel',
  /**
   * Grants permission to retriev information about a detector instance
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_iotevents-data_DescribeDetector.html
   */
  DescribeDetector = 'iotevents:DescribeDetector',
  /**
   * Grants permission to retrieve information about a detector model
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_DescribeDetectorModel.html
   */
  DescribeDetectorModel = 'iotevents:DescribeDetectorModel',
  /**
   * Grants permission to retrieve the detector model analysis information
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_DescribeDetectorModelAnalysis.html
   */
  DescribeDetectorModelAnalysis = 'iotevents:DescribeDetectorModelAnalysis',
  /**
   * Grants permission to retrieve an information about Input
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_DescribeInput.html
   */
  DescribeInput = 'iotevents:DescribeInput',
  /**
   * Grants permission to retrieve the current settings of the AWS IoT Events loggin
   * g options
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_DescribeLoggingOptions.html
   */
  DescribeLoggingOptions = 'iotevents:DescribeLoggingOptions',
  /**
   * Grants permission to retrieve the detector model analysis results
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_GetDetectorModelAnalysisResults.html
   */
  GetDetectorModelAnalysisResults = 'iotevents:GetDetectorModelAnalysisResults',
  /**
   * Grants permission to list all the versions of an alarm model
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_ListAlarmModelVersions.html
   */
  ListAlarmModelVersions = 'iotevents:ListAlarmModelVersions',
  /**
   * Grants permission to list the alarm models that you created
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_ListAlarmModels.html
   */
  ListAlarmModels = 'iotevents:ListAlarmModels',
  /**
   * Grants permission to retrieve information about all alarm instances per alarmMo
   * del
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_iotevents-data_ListAlarms.html
   */
  ListAlarms = 'iotevents:ListAlarms',
  /**
   * Grants permission to list all the versions of a detector model
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_ListDetectorModelVersions.html
   */
  ListDetectorModelVersions = 'iotevents:ListDetectorModelVersions',
  /**
   * Grants permission to list the detector models that you created
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_ListDetectorModels.html
   */
  ListDetectorModels = 'iotevents:ListDetectorModels',
  /**
   * Grants permission to retrieve information about all detector instances per dete
   * ctormodel
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_iotevents-data_ListDetectors.html
   */
  ListDetectors = 'iotevents:ListDetectors',
  /**
   * Grants permission to list one or more input routings
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_ListInputRoutings.html
   */
  ListInputRoutings = 'iotevents:ListInputRoutings',
  /**
   * Grants permission to lists the inputs you have created
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_ListInputs.html
   */
  ListInputs = 'iotevents:ListInputs',
  /**
   * Grants permission to list the tags (metadata) which you have assigned to the re
   * source
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_ListTagsForResource.html
   */
  ListTagsForResource = 'iotevents:ListTagsForResource',
  /**
   * Grants permission to set or update the AWS IoT Events logging options
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_PutLoggingOptions.html
   */
  PutLoggingOptions = 'iotevents:PutLoggingOptions',
  /**
   * Grants permission to start the detector model analysis
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_StartDetectorModelAnalysis.html
   */
  StartDetectorModelAnalysis = 'iotevents:StartDetectorModelAnalysis',
  /**
   * Grants permission to adds to or modifies the tags of the given resource.Tags ar
   * e metadata which can be used to manage a resource
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_TagResource.html
   */
  TagResource = 'iotevents:TagResource',
  /**
   * Grants permission to remove the given tags (metadata) from the resource
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_UntagResource.html
   */
  UntagResource = 'iotevents:UntagResource',
  /**
   * Grants permission to update an alarm model
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_UpdateAlarmModel.html
   */
  UpdateAlarmModel = 'iotevents:UpdateAlarmModel',
  /**
   * Grants permission to update a detector model
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_UpdateDetectorModel.html
   */
  UpdateDetectorModel = 'iotevents:UpdateDetectorModel',
  /**
   * Grants permission to update an input
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_UpdateInput.html
   */
  UpdateInput = 'iotevents:UpdateInput',
  /**
   * Grants permission to update input routing
   *
   * See https://docs.aws.amazon.com/iotevents/latest/apireference/API_UpdateInputRouting.html
   */
  UpdateInputRouting = 'iotevents:UpdateInputRouting',
}
